import { api } from "./api";

export interface RoleAccess {
  id: string;
  role_id: string;
  provider_id: string;
  allowed_models: string[];
  created_at: string;
}

export interface UserAccess {
  id: string;
  user_id: string;
  org_id: string;
  provider_id: string;
  allowed_models: string[];
  created_at: string;
}

export const providerAccessService = {
  listRoleAccess: (orgId: string) =>
    api.get<RoleAccess[]>(`/orgs/${orgId}/provider-access`),

  createRoleAccess: (orgId: string, data: { role_id: string; provider_id: string; allowed_models: string[] }) =>
    api.post(`/orgs/${orgId}/provider-access`, data),

  deleteRoleAccess: (orgId: string, accessId: string) =>
    api.delete(`/orgs/${orgId}/provider-access/${accessId}`),

  listUserAccess: (orgId: string) =>
    api.get<UserAccess[]>(`/orgs/${orgId}/user-provider-access`),

  createUserAccess: (orgId: string, data: { user_id: string; provider_id: string; allowed_models: string[] }) =>
    api.post(`/orgs/${orgId}/user-provider-access`, data),

  deleteUserAccess: (orgId: string, accessId: string) =>
    api.delete(`/orgs/${orgId}/user-provider-access/${accessId}`),
};
